import { IDmMucHocPhiTheoCTDTCopyRequest } from "../../model/request/category/dmMucHocPhiTheoCTDTCopyRequest";
import { IDmMucHocPhiTheoCTDTCopyKyThuRequest } from "../../model/request/category/dmMucHocPhiTheoCTDTCopyKyThuRequest";
import { IDmMucHocPhiTheoCTDTViewModelRequest } from "../../model/request/category/dmMucHocPhiTheoCTDTViewModelRequest";
import { IMucHocPhiTheoCTDT } from "../../model/respone/category/IDmMucHocPhiTheoCTDT";
import { apiClient } from "../apiClient";

export const MUC_HOC_PHI_THEO_CTDT_ENDPOINT = "muc-hoc-phi-theo-ctdt";

export const mucHocPhiTheoCTDTApi = {
  SelectCTDTs: (payload: IDmMucHocPhiTheoCTDTViewModelRequest) =>
    apiClient.post(`${MUC_HOC_PHI_THEO_CTDT_ENDPOINT}/select-ctdts`, {
      id_he: payload.id_he,
      khoa_hoc: payload.khoa_hoc,
      id_nganh: payload.id_nganh,
      search_key: payload.search_key,
    }),

  Select: (payload: IDmMucHocPhiTheoCTDTViewModelRequest) =>
    apiClient.post(`${MUC_HOC_PHI_THEO_CTDT_ENDPOINT}/select-data`, payload),

  // Danh sách môn CTĐT theo sinh viên (modal "Chương trình đào tạo") + đơn giá (xuyên suốt các năm).
  SelectMonsBySinhVien: (id_sv: string) =>
    apiClient.get(
      `${MUC_HOC_PHI_THEO_CTDT_ENDPOINT}/select-mons-by-sinh-vien/${id_sv}`
    ),

  Save: (payload: IMucHocPhiTheoCTDT[]) =>
    apiClient.post(`${MUC_HOC_PHI_THEO_CTDT_ENDPOINT}/save-data`, payload),

  Lock: (payload: IDmMucHocPhiTheoCTDTViewModelRequest) =>
    apiClient.post(`${MUC_HOC_PHI_THEO_CTDT_ENDPOINT}/true/lock-or-unlock`, payload),

  Unlock: (payload: IDmMucHocPhiTheoCTDTViewModelRequest) =>
    apiClient.post(`${MUC_HOC_PHI_THEO_CTDT_ENDPOINT}/false/lock-or-unlock`, payload),

  Copy: (payload: IDmMucHocPhiTheoCTDTCopyRequest) =>
    apiClient.post(`${MUC_HOC_PHI_THEO_CTDT_ENDPOINT}/copy`, payload),

  CopyKyThu: (payload: IDmMucHocPhiTheoCTDTCopyKyThuRequest) =>
    apiClient.post(`${MUC_HOC_PHI_THEO_CTDT_ENDPOINT}/copy-ky-thu`, payload),
};
